import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

import { Table } from "@devexpress/dx-react-grid-bootstrap4";

export const TableRow = (props: PropsWithChildren<Table.DataRowProps>) => {
  return (
    <Table.Row
      {...props}
      className={clsx("max-h-8 h-8", {
        even: props.row.index % 2 === 0,
        odd: props.row.index % 2 === 1,
      })}
    />
  );
};
